module.exports = __webpack_public_path__ + "static/media/masaMenu.4ac47334.pdf";